interface OpsVettingMerchFormHeaderProps {
	icon: React.ReactNode
	title: string | React.ReactNode
	description: string | React.ReactNode
	variant?: 'base' | 'blue'
	endSlot?: React.ReactNode
}

export const OpsVettingMerchFormHeader = ({
	icon,
	title,
	description,
	variant = 'base',
	endSlot
}: OpsVettingMerchFormHeaderProps) => {
	return (
		<div
			className={`flex flex-col gap-3 ${variant === 'blue' ? 'text-blue-700' : 'text-neutral-900'}`}
		>
			{icon}
			<div className='flex w-full flex-row items-end justify-between gap-1'>
				<div className='flex flex-col gap-1'>
					<h3 className='font-semibold text-lg'>{title}</h3>
					<small className='text-base text-neutral-900'>
						{description}
					</small>
				</div>
				{endSlot}
			</div>
		</div>
	)
}
